const CURRENCIES_WITHOUT_CENTS = ['CNY', 'TWD', 'RUB'];
export default function createTranslatorProps(translator) {
  const {
    translate,
    localize,
    createNumberFormat,
    mapCurrencyISOToSymbol,
    formatUserAmount
  } = translator;
  return {
    __: translate,
    formatDate: (date, format = 'LLL Z', toUtc = true) => localize(date, toUtc).format(format),
    formatNumber: (number, options = {}) => createNumberFormat({
      style: 'decimal',
      ...options
    }).format(number),
    formatUserAmount: amount => formatUserAmount(amount),
    formatPrice: (price, currency) => {
      const options = {};
      const noCents = CURRENCIES_WITHOUT_CENTS.includes(currency);
      if (currency) {
        options.style = 'currency';
        options.currency = currency;
        options.maximumFractionDigits = noCents ? 0 : undefined;
        options.minimumFractionDigits = noCents ? 0 : undefined;
        return createNumberFormat(options).format(price);
      }
      if (global.__DEV__) {
        console.warn('<Price /> has no currency set');
      }
      return createNumberFormat({
        style: 'decimal',
        ...options
      }).format(price);
    },
    formatCurrency: mapCurrencyISOToSymbol,
    localize
  };
}